import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import AcademicCalendarService from "../../src/Services/AcademicCalendar.service";
const AcademicCalendarLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => {
            return AcademicCalendarService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return AcademicCalendarService.getAcademicCalendars(search);
        },
        optionRenderer: function locationRenderer(academicCalendar) {
            return _jsx("span", { children: academicCalendar.displayName });
        },
        labelKey: "displayName",
    });
};
export default AcademicCalendarLookup;
